import React from 'react'

export default function UpperHeader({ child }) {
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-sm-6 text-center my-auto">
                    <img src={`${child ? "../logoInicial.png" : "logoInicial.png"}`} alt='Logo Inicial' className='img-fluid' style={{ marginBottom: "10px" }} />
                </div>
                <div className="col-md-4 text-center my-auto">
                    <img src={`${child ? "../gobierno-municipal-chihuahua.jpg" : "gobierno-municipal-chihuahua.jpg"}`} alt='Gobierno' className='img-fluid hide-mobile' style={{ marginBottom: "10px" }} />
                </div>
                <div className="col-md-4 col-sm-6 text-center my-auto mb-2">
                    <img src={`${child ? "../logos.jpg" : "logos.jpg"}`} alt='Direccion' className='img-fluid hide-mobile' style={{ marginBottom: "10px" }} />
                    <a href="https://www.facebook.com/profile.php?id=100090345052609&mibextid=ZbWKwL" className='colorblue noLink linko my-auto' target='_blank' rel='noreferrer'>
                        <span className='mb-4' style={{ position: "relative", top: 4 }}>Siguenos en Facebook</span>&nbsp;
                        <img src={`${child ? "../facebook.png" : "facebook.png"}`} alt="Facebook" style={{ width: 25, height: 25 }} />
                    </a>
                </div>
            </div>
        </div>
    )
}
